export const CONTRACT_MODES = {
    EDIT: 'edit',
    CREATE: 'create'
}